import { z } from 'zod';

import { orderIdSchema, orderLogsResultSchema } from '../orderLogs.mts';
import { AvaAIToolExecution } from '../toolExecution.mts';

export const getOrderSummaryInputSchema = z.strictObject({
  orderId: orderIdSchema,
});

export const getOrderSummaryToolContract = {
  execution: AvaAIToolExecution.Server,
  name: 'getOrderSummary',
  inputSchema: getOrderSummaryInputSchema,
  outputSchema: orderLogsResultSchema,
} as const;
